// Shared by world.ts and levels.ts
export const K = 'henhouse';
export const DEG = Math.PI / 180;
